function convertAmountInCents(
        value: string | number
): number {
        value = value.toString();
        parseFloat(value.replace(",", "")).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})
        const amountHaveDot = value.includes(".");
        let amountInCents;

        if(amountHaveDot){
                amountInCents = parseFloat(value.replace(",", ".").replaceAll(".", ""));
        } else {
                amountInCents = parseFloat(value.replace(",", ".")) * 100;
        }

        return Math.round(amountInCents);
}

export default convertAmountInCents;